var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "#CBA67A",
    strokeWidth: 2,
    strokeLinecap: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.007 1.76094C8.04665 2.0928 6.7193 2.93807 5.96255 4.36928C4.60668 6.93355 5.18346 8.81033 4.7093 10.7051C4.23515 12.5999 2.78144 13.2351 1.73589 14.7181C0.919783 15.8757 0.790868 18.6914 2.25338 20.0973C3.70029 21.4772 5.03456 22.7567 7.63234 22.3668C10.2041 21.9926 11.5007 20.2593 14.2027 19.7185C16.9046 19.1777 19.1424 19.6729 20.5803 18.3896C22.0881 17.0439 23.6565 13.322 22.3093 10.6356C21.2256 8.47482 18.3126 8.34359 17.0272 6.31824C15.7418 4.29289 15.3493 3.14732 14.2948 2.5542C12.8846 1.761 11.6089 1.48975 10.007 1.76094Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6001 12.5558H14.4001M11.9557 10.2002V15.0002"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.6e05ce83a4177d2c33eb8989affd9f12.svg";
export { ForwardRef as ReactComponent };